var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4c3a11f5a6fbab4fda038bc592666c17a4119be5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-staging@xyte-0n"]={id:"4c3a11f5a6fbab4fda038bc592666c17a4119be5"};
      